var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9432 5.57147C18.0727 5.15515 17.9802 4.68874 17.6726 4.34914L15.9255 2.41991C15.6834 2.15263 15.3385 2 14.9766 2H9.02341C8.66147 2 8.31656 2.15263 8.07451 2.41991L8.02679 2.4726L17.9432 5.57147Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91752 3.69751L6.32738 4.34916C5.93308 4.78456 5.89222 5.42843 6.21964 5.90789L15.5379 8.81986L17.0467 6.8629L6.91752 3.69751Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81232 7.97711L14.5616 10.0863L12.75 12.4359V14.8637L14.0808 14.0508C14.3428 13.8907 14.6615 14.1331 14.597 14.4433L14.1284 16.6996C14.1017 16.8281 14.1431 16.9618 14.2369 17.0493L15.883 18.5863C16.1094 18.7977 15.9876 19.1898 15.6859 19.2215L13.4911 19.4522C13.366 19.4653 13.2574 19.5479 13.2068 19.6683L12.319 21.782C12.197 22.0727 11.803 22.0727 11.681 21.782L10.7932 19.6683C10.7426 19.5479 10.634 19.4653 10.5089 19.4522L8.31414 19.2215C8.01235 19.1898 7.89062 18.7977 8.11696 18.5863L9.76307 17.0493C9.85685 16.9618 9.89834 16.8281 9.87164 16.6996L9.40297 14.4433C9.33853 14.1331 9.65722 13.8907 9.91918 14.0508L11.25 14.8637V12.4359L7.81232 7.97711Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal4);
export default __webpack_public_path__ + "static/media/medal-4.5765acb5e512a90471e434f0e1d0a012.svg";
export { ForwardRef as ReactComponent };